import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import AdminEmployeeQueue from "./pages/AdminEmployeeQueue";
import AutoAssignRules from "./pages/AutoAssignRules";
import AdminDashboard from "./pages/AdminDashboard";
import Intake from "./pages/Intake";
import OrderWorkspace from "./pages/OrderWorkspace";
import AiSpend from "./pages/AiSpend";
import Users from "./pages/Users";
import Chat from "./pages/Chat";
import Meet from "./pages/Meet";
import DirectMessages from "./pages/DirectMessages";
import CountyPortals from "./pages/CountyPortals";
import MarketingHub from "./pages/MarketingHub";
import SearchInstructions from "./pages/SearchInstructions";
import CourtLinks from "./pages/CourtLinks";

function Protected({ children, adminOnly }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function Landing() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors offset={24} />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Protected><EmployeeDashboard /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><AdminDashboard /></Protected>} />
            <Route path="/admin/users" element={<Protected adminOnly><Users /></Protected>} />
            <Route path="/admin/employees/:id/queue" element={<Protected adminOnly><AdminEmployeeQueue /></Protected>} />
            <Route path="/admin/auto-assign" element={<Protected adminOnly><AutoAssignRules /></Protected>} />
            <Route path="/intake" element={<Protected adminOnly><Intake /></Protected>} />
            <Route path="/admin/ai-spend" element={<Protected adminOnly><AiSpend /></Protected>} />
            <Route path="/admin/county-portals" element={<Protected adminOnly><CountyPortals /></Protected>} />
            <Route path="/admin/marketing" element={<Protected adminOnly><MarketingHub /></Protected>} />
            <Route path="/admin/search-instructions" element={<Protected adminOnly><SearchInstructions /></Protected>} />
            <Route path="/admin/court-links" element={<Protected adminOnly><CourtLinks /></Protected>} />
            <Route path="/chat" element={<Protected><Chat /></Protected>} />
            <Route path="/messages" element={<Protected><DirectMessages /></Protected>} />
            <Route path="/meet" element={<Protected><Meet /></Protected>} />
            <Route path="/orders/:id" element={<Protected><OrderWorkspace /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
